<div>
  <label class="form-label file-label">{{title}}</label>
  @if (projectAssets) {
  <div class="existance-wrapper">
    <div class="drag-btn">
      <button type="button" class="btn btn-outline-secondary add-new-file">
        <img src="assets/images/svg/upload-img.svg" alt="" />
        رفع {{title}}
      </button>
      <input type="file" name="" (change)="handleFileInput($event.target.files)" accept="image/png,image/jpeg"
        class="file-input form-control" />
      @if (fileSizeErr) {
      <div class="file-error">
        <span>عفوا لا يمكن رفع صور حجم اكبر من {{MAX_File_SIZE / 1000000}} MB </span>
      </div>
      }
    </div>
    <div class="edit-wrapper">
      <img class="logo" [src]="projectAssets" [alt]="title">
      <button class="btn delete-wrapper" type="button" (click)="deleteFile()">
        <img src="assets/images/svg/DELETE1.svg" alt="">
      </button>
    </div>
  </div>
  }
  @if (!projectAssets) {
  <div class="drag-btn">
    <button type="button" class="btn btn-outline-secondary add-new-file">
      <img src="assets/images/svg/upload-img.svg" alt="" />
      رفع {{title}}
    </button>
    <input type="file" name="" accept="image/png, image/jpeg" (change)="handleFileInput($event.target.files)"
      class="file-input form-control" />
    @if (fileSizeErr) {
    <div class="file-error">
      <span>عفوا لا يمكن رفع صور حجم اكبر من {{MAX_File_SIZE / 1000000}} MB </span>
    </div>
    }
  </div>
  }
  @if (isFile && isdeleteUploadedFile) {
  <div class="existance-wrapper">
    <div class="existance">
      <img src="assets/images/svg/file-name-icon.svg" alt="">
      <span>{{fileName}}</span>
    </div>
    <div>
      <button class="btn delete-wrapper" type="button" (click)="deleteUploadedFile()">
        <img src="assets/images/svg/DELETE1.svg" alt="">
      </button>
    </div>
  </div>
  }
  <p class="notes">الدقة الموصى بها هي 300 × 1200</p>
</div>
